import { registerCheckoutBlock } from '@woocommerce/blocks-checkout';
import { getSetting } from '@woocommerce/settings';
import { useState, useEffect, createElement } from '@wordpress/element';
import metadata from './block.json';

/* Get captcha type from settings*/
const { captcha_provider } = getSetting( 'i13-recaptcha-checkout-block_data', '' );

/**
 * The Loader Component
 * This is what WooCommerce "sees" immediately.
 */
const CaptchaComponentLoader = ( props ) => {
    const [ LoadedBlock, setLoadedBlock ] = useState( null );
    const [ error, setError ] = useState( false );

    useEffect( () => {
        /* This is where the dynamic loading happens*/
        const loadBlock = async () => {
            try {
                let module;

                if ( captcha_provider === 'turnstile' ) {
                    module = await import( './blocks/turnstile-block.js' );
                }
                 else if ( captcha_provider === 'hcaptcha' ) {

					  module = await import( './blocks/hcaptcha-block.js' );
				}
                else {
                    module = await import( './blocks/recaptcha-block.js' );
                }


                setLoadedBlock( () => module.default );
            } catch ( err ) {
                console.error( 'reCaptcha for woo-Dynamic Import failed:', err );
                setError( true );
            }
        };

        loadBlock();
    }, [] );

    if ( error ) return null;

    /* If LoadedBlock is ready, render it. Otherwise, render nothing (blank)
    while the script downloads in the background.*/
    return LoadedBlock ? createElement( LoadedBlock, props ) : null;
};

/* IMPORTANT: Register synchronously so WooCommerce "catches" it.*/
registerCheckoutBlock( {
    metadata,
    component: CaptchaComponentLoader,
} );
